import React, { useLayoutEffect } from 'react';
import { IOverrideFilterInfo } from '../../../../redux/Calculations/CurrentCalculationSessionInterface';
import { getOperatorPattern } from '../../utils';
import { Box, FormControl, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import { fontSize, palette } from '../../../..';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useDispatch } from 'react-redux';
import { updateFilterPanel } from '../../../../redux/Calculations/CalculationsActions';
import InputField from '../../Conditions/Evaluation/InputField';
import { CanvasSelect } from '../../common/CanvasSelect';

interface ISearchCondition {
  propKey: string;
  filterInfo: IOverrideFilterInfo;
  ensureNodeVisible :()=> void;
}

type OperatorOption = {
  key: string;
  value: string;
};

function SearchCondition({ filterInfo, propKey, ensureNodeVisible }: ISearchCondition) {
  const Operators = getOperatorPattern(filterInfo.dataType);
  const dispatch = useDispatch();

  const handleOperatorChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value as string;
    dispatch(
      updateFilterPanel(propKey, 'update', filterInfo.filterId, {
        ...filterInfo,
        operator: value,
      }),
    );
  };
  const getType = () => {
    if (['decimal', 'integer'].includes(filterInfo.dataType)) return 'number';
    if (['date', 'timestamp'].includes(filterInfo.dataType))
      return filterInfo.timeGrain === 'date' ? 'date' : 'text';
    return 'text';
  };
  const updateUserSelection = (value: string, index: 0 | 1) => {
    const newSelection = [...filterInfo.userSelection];
    newSelection[index] = value;
    dispatch(
      updateFilterPanel(propKey, 'update', filterInfo.filterId, {
        ...filterInfo,
        userSelection: newSelection,
      }),
    );
  };

  const operatorOptions: OperatorOption[] = Operators.map((op) => ({
    key: op.key,
    value: op.value,
  }));

  useLayoutEffect(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(()=>{
        ensureNodeVisible && ensureNodeVisible();
      })
    });
  }, [])

  const selectedOperator: OperatorOption | null =
    operatorOptions.find((op) => op.key === filterInfo.operator) ?? null;

  return (
    <Box>
      {/* <FormControl
        fullWidth
        size="small"
        sx={{
          marginBottom: '0.5rem',
          '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
              borderColor: '#2bb9bb',
            },
            '&:hover fieldset': {
              borderColor: '#2bb9bb',
            },
          },
        }}
      >
        <Select
          // disabled={disabled}
          sx={{
            height: '1.5rem',
            fontSize: fontSize.large,
            textAlign: 'left',
            '.MuiSelect-icon': {
              fontSize: '18px',
              marginRight: '0.21rem',
              color: palette.primary.contrastText,
              // right: "3.5px",
            },
          }}
          IconComponent={KeyboardArrowDownIcon}
          onChange={handleOperatorChange}
          value={filterInfo.operator}
          variant="outlined"
        >
          {Operators.map((operator) => {
            return (
              <MenuItem key={operator.key} value={operator.key}>
                <Typography
                  sx={{
                    width: 'auto',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: '12px',
                  }}
                >
                  {operator.value}
                </Typography>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl> */}

      <Box sx={{ marginBottom: '0.5rem', }}>
        <CanvasSelect<OperatorOption>
          value={selectedOperator}
          options={operatorOptions}
          getLabel={(opt) => opt.value}
          getKey={(opt) => opt.key}
          onChange={(opt) => {
            dispatch(
              updateFilterPanel(propKey, 'update', filterInfo.filterId, {
                ...filterInfo,
                operator: opt.key,
              }),
            );
          }}
          style={{
            height: '1.5rem',
            fontSize: fontSize.large,
            paddingRight : "5px"
          }}
        />
      </Box>

      {filterInfo.operator !== 'blank' ? (
        <>
          <Box
            sx={{
              height: '1.5rem',
              padding: '0.3rem',
              border: `1px solid  #d3d3d3`,
              display: 'flex',
              alignItems: 'center',
              borderRadius: '5px',
            }}
          >
            <InputField
              value={filterInfo.userSelection[0] ?? ''}
              onBlur={(value) => updateUserSelection(value, 0)}
              type={getType()}
              isDecimal={filterInfo.dataType === 'decimal'}
              applyExcludeStyle={filterInfo.shouldExclude}
            />
          </Box>
          {filterInfo.operator === 'between' && (
            <Box
              sx={{
                height: '1.5rem',
                padding: '0.3rem',
                border: `1px solid  #d3d3d3`,
                display: 'flex',
                alignItems: 'center',
                borderRadius: '5px',
                marginTop: '0.5rem',
              }}
            >
              <InputField
                value={filterInfo.userSelection[1] ?? ''}
                onBlur={(value) => updateUserSelection(value, 1)}
                type={getType()}
                isDecimal={filterInfo.dataType === 'decimal'}
                applyExcludeStyle={filterInfo.shouldExclude}
              />
            </Box>
          )}
        </>
      ) : null}
    </Box>
  );
}

export default SearchCondition;
